import type { Signal } from "@suse-o11y/signal";
import type { StreamRegistry } from "@suse-o11y/stream-manager/registry";
import type { StreamStore } from "@suse-o11y/stream-manager/store";
import { useRequiredContext } from "@suse-o11y/use-required-context";
import React from "react";

import type { manager } from "./manager";

export interface WebSocketContextValue {
	registry: Signal<StreamRegistry<typeof manager>>;
	store: Signal<StreamStore<typeof manager>>;
}

const WebSocketContext = React.createContext<null | WebSocketContextValue>(null);

export const WebSocketContextProvider = WebSocketContext.Provider;

export const useWebSocketContext = (): WebSocketContextValue =>
	useRequiredContext(WebSocketContext, {
		providerName: "WebSocketProvider",
	});
